/**
 * @generated SignedSource<<83d26d6b438637a34349240350301936>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ProductSkuOfferDeliveryChannel = "DELIVERY" | "PICKUP_IN_POINT" | "TAKE_AWAY";
import { FragmentRefs } from "relay-runtime";
export type ProductSkuAvailabilityDelivery_ProductSkuOfferConnection$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly deliveryChannel: ProductSkuOfferDeliveryChannel;
      readonly netPrice: {
        readonly amount: number;
      };
      readonly deliveryAvailabilities: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly name: string;
            readonly shippingEstimate: string;
            readonly netPrice: {
              readonly amount: number;
            };
          };
        }>;
      };
    };
  }>;
  readonly " $fragmentType": "ProductSkuAvailabilityDelivery_ProductSkuOfferConnection";
};
export type ProductSkuAvailabilityDelivery_ProductSkuOfferConnection$key = {
  readonly " $data"?: ProductSkuAvailabilityDelivery_ProductSkuOfferConnection$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductSkuAvailabilityDelivery_ProductSkuOfferConnection">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "concreteType": "Money",
  "kind": "LinkedField",
  "name": "netPrice",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "amount",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductSkuAvailabilityDelivery_ProductSkuOfferConnection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductSkuOfferEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProductSkuOffer",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "deliveryChannel",
              "storageKey": null
            },
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "ProductSkuOfferDeliveryAvailabilityConnection",
              "kind": "LinkedField",
              "name": "deliveryAvailabilities",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ProductSkuOfferDeliveryAvailabilityEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ProductSkuOfferDeliveryAvailability",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "shippingEstimate",
                          "storageKey": null
                        },
                        (v0/*: any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProductSkuOfferConnection",
  "abstractKey": null
};
})();

(node as any).hash = "ae5d3857e554901f0c2392f958ba3eaa";

export default node;
